import Vue from 'vue'
import Vuex from 'vuex'

import home from './modules/home/home.js'
import scrollBar from './modules/scroll_bar/scroll_bar.js'
import coursesCategory from './modules/courses_category/courses_category.js'
import course from './modules/course/course.js'
import loginState from './modules/login_state/login_state.js'
import path from './modules/path/path.js'
import post from './modules/post/post.js'
import question from './modules/questions/question.js'
import questions from './modules/questions/questions.js'
import user from './modules/user/user.js'
import loggedInfo from './modules/logged_info/logged_info.js'
import profile from './modules/user/profile.js'
import search from './modules/search/search.js'
import library from './modules/library/library.js'
import comments from './modules/comments/comments.js'
import reports from './modules/reports/reports.js'
import warningBar from './modules/warning_bar/warning_bar.js'
import live from './modules/live/live.js'
import contests from './modules/contests/contests.js'
import main from './modules/main/main.js'
import learning from './modules/learning/learning.js'
import plus from './modules/plus/plus.js'
import skill from './modules/skill/skill.js'
import skill_plan from './modules/skill_plan/skill_plan.js'
import skill_submit from './modules/skill_submit/skill_submit.js'
import eval_position from './modules/eval/eval_position.js'
import position_target from './modules/eval/position_target.js'
import channel from './modules/channel/channel.js'

import plan from '@/apps/plan/plan_store.js'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const dynamicModules = {}
const files = require.context('@/apps/', true, /_store\.js$/)

const getQueryStr = (name) => {
    debugger
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
};

const dynamicImportModules = (modules, file, splits, index = 0) => {
    if (index == 0 && splits[0] == 'modules') {
        ++index
    }
    if (splits.length == index + 1) {
        if ('index' == splits[index]) {
            modules[splits[index - 1]] = files(file).default
        } else {
            modules.modules[splits[index]] = files(file).default
        }
    } else {
        let tmpModules = {}
        if ('index' == splits[index + 1]) {
            tmpModules = modules
        } else {
            modules[splits[index]] = modules[splits[index]] ? modules[splits[index]] : {namespaced: true, modules: {}}
            tmpModules = modules[splits[index]]
        }
        dynamicImportModules(tmpModules, file, splits, ++index)
    }
}

files.keys().filter(file => file != './index.js').forEach(file => {
    let splits = file.replace(/(\.\/|\.js)/g, '').split('/');
    // debugger
    // files(file).default
    dynamicImportModules(dynamicModules, file, splits)
})

export default new Vuex.Store({
    modules: {
        home,
        main,
        scrollBar,
        coursesCategory,
        course,
        loginState,
        path,
        questions,
        post,
        question,
        user,
        loggedInfo,
        profile,
        search,
        library,
        comments,
        reports,
        warningBar,
        live,
        contests,
        learning,
        plus,
        dynamicModules,
        skill,
        skill_plan,
        skill_submit,
        eval_position,
        position_target,
        channel,
        plan
    },
  strict: debug
  // plugins: debug ? [createLogger()] : []
})
